import './App.scss';
import { Header } from './components/moleculas/header/Header';
import { InputForm } from './components/moleculas/inputform/InputForm2';
import { MultiForm } from './components/moleculas/multiform/Multiform';
import { useState, useMemo } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { modelSettings } from './settings/settings';
import { ModelSettings } from './components/moleculas/inputform/types';

import { MainFormWithProvider } from './components/moleculas/collapseform/MainForm';

function App() {
  const [activeTab, setActiveTab] = useState(1);
  const modelName = process.env.REACT_APP_MODEL_NAME || '';
  const currentModelSettings = useMemo(
    () => modelName && (modelSettings[modelName] as ModelSettings),
    [modelName],
  );

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  const tabs = useMemo(
    () => (
      <Tabs value={activeTab} onChange={handleTabChange} centered>
        <Tab label="About" />
        <Tab label="Run Model" />
        <Tab label="Contact" />
      </Tabs>
    ),
    [activeTab],
  );

  const renderTabContent = useMemo(() => {
    if (!currentModelSettings || !currentModelSettings.isContentMenuEnabled) {
      return null;
    }

    switch (activeTab) {
      case 0:
        return (
          <>
            <div
              dangerouslySetInnerHTML={{
                __html: currentModelSettings.aboutContent || '',
              }}
            />
            <div
              dangerouslySetInnerHTML={{
                __html: currentModelSettings.readingContent || '',
              }}
            />
            <div
              dangerouslySetInnerHTML={{
                __html: currentModelSettings.eemdlContent || '',
              }}
            />
            <div
              dangerouslySetInnerHTML={{
                __html: currentModelSettings.ceesaContent || '',
              }}
            />
          </>
        );
      case 2:
        return (
          <div
            dangerouslySetInnerHTML={{
              __html: currentModelSettings.contactContent || '',
            }}
          />
        );

      default:
        return null;
    }
  }, [activeTab, currentModelSettings]);

  const renderForm = useMemo(() => {
    if (activeTab !== 1) return null;

    if (modelName === 'meet_pneumatics') {
      return <MultiForm modelName={modelName} />;
    }

    if (modelName === 'lng_lca') {
      return <MainFormWithProvider />;
    }

    if (modelName) {
      return <InputForm modelName={modelName} />;
    }

    return null;
  }, [activeTab, modelName]);

  return (
    <>
      {modelName ? (
        <>
          <Header modelName={modelName} tabsPortal={tabs} />
          {renderTabContent && (
            <Box sx={{ padding: 2, paddingBottom: 0 }}>{renderTabContent}</Box>
          )}
          {renderForm}
        </>
      ) : (
        <p>Incorrect model name</p>
      )}
    </>
  );
}

export default App;
